module.exports = __webpack_public_path__ + "static/media/Template.a3e5f9ab.svg";